export default __webpack_public_path__ + "static/media/directions.acb27a39.png";